export const URL_PARAM_PAYGROUP = 'paygroup';
export const URL_PARAM_PAYROLLRUN = 'payrollrun';
export const URL_PARAM_PAYROLL_GROUP_ID = 'payrollgroup';
